import React, { Component } from "react";
import { DraggableCore } from "react-draggable";

class Drag extends Component {
  onDrag = (e, ui) => {
    const newtop = this.props.top + ui.deltaY;
    const newleft = this.props.left + ui.deltaX;
    this.props.onDrag(this.props.id, { top: newtop, left: newleft });
  };

  render() {
    return (
      <DraggableCore
        onDrag={this.onDrag}
        disabled={this.props.disabled}
        axis={this.props.disabled ? "none" : "both"}
        position={{ x: this.props.left, y: this.props.top }}>
        <div
          style={{
            width: this.props.width,
            height: this.props.height,
            transform: "translate(" + this.props.left + "px," + this.props.top + "px)",
            cursor: "pointer",
            position: "absolute"
          }}>
          {this.props.children}
        </div>
      </DraggableCore>
    );
  }
}

export default Drag;



// WEBPACK FOOTER //
// ./src/canvas/enhancers/draggable.js